import { useRouteContext } from '@tanstack/react-router';
import { useMediaQuery } from 'usehooks-ts';

// Server-rendered pages answer with the root route's user-agent guess
// (desktop on CDN-shared pages, which cannot vary by device). The first client
// render returns the same answer so hydration matches, and the hook's layout
// effect swaps in the real value before a client-side mount paints.
export const useViewportMediaQuery = (
  query: string,
  matches: { mobile: boolean; desktop: boolean },
) => {
  const viewport = useRouteContext({
    from: '__root__',
    select: (ctx) => ctx.viewport ?? 'desktop',
  });
  return useMediaQuery(query, {
    defaultValue: matches[viewport],
    initializeWithValue: false,
  });
};
